import { Box, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import Tooltip from "@mui/material/Tooltip";
import { useForm } from "react-hook-form";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonTransactionPaginationTable from "../../../../common/components/CommonTable/CommonTransactionPaginationTable";
import DatePickerField from "../../../../common/components/FormFields/DatePickerFieldNew";
import { MaintenanceListingNew } from "../../../services/maintenanceServices/MaintenanceServices";
import MaintenanceEditDialog from "./MaintenanceEdit";
import MaintenanceViewDialog from "./MaintenanceView";


export default function MaintenanceList() {
    const DrawerHeader = styled("div")(({ theme }) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
    }));

    const [dataResult, setDataResult] = useState([]);
    const [count, setCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [openEdit, setOpenEdit] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openView, setOpenView] = useState(false);
    const [viewRow, setViewRow] = useState(null);
    const [editItemInfoId, setEditItemInfoId] = useState(null);
    const [selectedItemDetails, setSelectedItemDetails] = useState(null);
    const [maintenanceId, setMaintenanceId] = useState(null);
    const [itemInfoId, setItemInfoId] = useState(null);

    const [filters, setFilters] = useState({
        fromDate: null,
        toDate: null,
    });

    const [snack, setSnack] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const handleEdit = (row) => {
        console.log("row.itemInfoId:", row.itemInfoId);
        setItemInfoId(row.itemInfoId);
    };


    const commonAutocompleteSx = {
        "& .MuiOutlinedInput-root": {
            height: 38,
        },
        "& .MuiOutlinedInput-input": {
            padding: "8px 10px",
        },
    };

    const { control, reset, getValues } = useForm({
        defaultValues: {
            fromDate: null,
            toDate: null,
        },
    });

    const RenderActions = (row) => {
        const id =
            row?.id ??
            row?.Id ??
            row?.["Id"];

        return (
            <Box className="flex items-center gap-2">

                <Tooltip title="View Maintenance">
                    <VisibilityOutlinedIcon
                        sx={{ color: "#1976d2", cursor: "pointer" }}
                        onClick={() => {
                            setViewRow(id);
                            setOpenView(true);
                        }}
                    />
                </Tooltip>

                <Tooltip title="Edit Maintenance">
                    <EditOutlinedIcon
                        sx={{ color: "#2e7d32", cursor: "pointer" }}
                        onClick={() => {
                            const maintenanceId = row?.Id ?? row?.id ?? row?.["Id"];
                            const itemInfoId =
                                row?.itemInfoId ??
                                row?.["Item Info Id"] ??
                                row?.["ItemInfoId"];

                            setMaintenanceId(maintenanceId);
                            setItemInfoId(itemInfoId);
                            setSelectedItemDetails(row);
                            setOpenEdit(true);
                        }}
                    />
                </Tooltip>
            </Box >
        );
    };

    const fetchMaintenanceList = async (pageValue, sizeValue, activeFilters = filters, forPagination) => {
        try {
            const payload = {
                page: pageValue + 1,
                size: sizeValue,
                fromDate: activeFilters.fromDate,
                toDate: activeFilters.toDate,
            };

            const response = await MaintenanceListingNew(payload);
            const res = response.data;
            if (forPagination) {
                setDataResult((prevData) => [...prevData, ...res?.result])
            } else {
                setDataResult(res?.result ?? []);
            }
            setCount(res?.count ?? 0);

            const rows = Array.isArray(res?.result)
                ? res.result
                : res?.result
                    ? [res.result]
                    : [];

            setDataResult(rows);
            setCount(res?.count ?? rows.length);

        } catch (error) {
            console.error("Maintenance listing error:", error);
            setDataResult([]);
            setCount(0);
        }
    };

    useEffect(() => {
        fetchMaintenanceList(page, rowsPerPage, filters);
    }, [page, rowsPerPage, filters]);

    const populateTable = (row, index) => ({
        "Sr No.": index + 1,
        "Item Name": row["Item Name"],
        "Maintenance No": row["Maintenance No"],
        "Maintenance Date": row["Maintenance Date"],
        "Next Maintenance Date": row["Next Maintenance Date"],
        "Service Agent": row["Service Agent"],
        "Department": row["Department"] ?? "-",
        "Under Warranty": row["Under Warranty"] ? "Yes" : "No",
    });

    return (
        <Box sx={{ display: "flex" }}>
            {/* <Sidebar /> */}

            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                {/* <DrawerHeader /> */}

                <h1 className="text-xl text-black font-Poppins mb-4">
                    Maintenance Listing
                </h1>


                <Box
                    sx={{
                        display: "flex",
                        alignItems: "flex-end",
                        gap: 1,
                        mb: 2,
                        flexWrap: "nowrap",
                        width: "fit-content",
                    }}
                >

                    <DatePickerField
                        control={control}
                        name="fromDate"
                        label="From Date"
                        inputFormat="dd-MM-yyyy"
                        sx={{ width: 220, ...commonAutocompleteSx }}

                    />

                    <DatePickerField
                        control={control}
                        name="toDate"
                        label="To Date"
                        inputFormat="dd-MM-yyyy"
                        sx={{ width: 220, ...commonAutocompleteSx }}
                    />

                    <CommonButton
                        searchIcon
                        className="bg-blue-800 text-white"
                        type="button"
                        sx={{ height: 40 }}
                        onClick={() => {
                            const { fromDate, toDate } = getValues();

                            const formattedFilters = {
                                fromDate: fromDate
                                    ? new Date(fromDate).toISOString().split("T")[0]
                                    : null,
                                toDate: toDate
                                    ? new Date(toDate).toISOString().split("T")[0]
                                    : null,
                            };

                            setFilters(formattedFilters);
                            setPage(0);
                        }}
                    />

                    <Button
                        variant="outlined"
                        sx={{ minWidth: 80 }}
                        color="error"
                        onClick={() => {

                            reset({
                                fromDate: null,
                                toDate: null,
                            });
                            setFilters({
                                fromDate: null,
                                toDate: null,
                            });

                            setPage(0);
                        }}
                    >
                        Reset
                    </Button>

                </Box>

                {dataResult.length > 0 ? (
                    <CommonTransactionPaginationTable
                        dataResult={dataResult}
                        page={page}
                        setPage={setPage}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                        count={count}
                        actionsRequired={true}
                        renderActions={RenderActions}
                        highlightRow={false}
                        populateTable={populateTable}
                        removeHeaders={["Sr No.", "srNo", "Item Info Id", "itemId", "Id", "id"]}

                    />

                ) : (
                    <h2 className="text-center text-gray-600 mt-20">
                        No Data Found
                    </h2>
                )}

            </Box>



            <MaintenanceViewDialog
                open={openView}
                onClose={() => setOpenView(false)}
                maintenanceId={viewRow}
            />

            <MaintenanceEditDialog
                open={openEdit}
                onClose={() => setOpenEdit(false)}
                maintenanceId={maintenanceId}
                itemDetails={selectedItemDetails}
                setSnack={setSnack}
                itemInfoId={itemInfoId}
            />

            <Snackbar
                open={snack.open}
                autoHideDuration={5000}
                onClose={() => setSnack({ ...snack, open: false })}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert
                    onClose={() => setSnack({ ...snack, open: false })}
                    severity={snack.severity}
                    variant="filled"
                    sx={{ width: "100%" }}
                >
                    {snack.message}
                </Alert>
            </Snackbar>

        </Box>
    );
}